/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryResource
 */
export interface CountryResource {
    /**
     * 
     * @type {string}
     * @memberof CountryResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResource
     */
    label: string;
}

/**
 * Check if a given object implements the CountryResource interface.
 */
export function instanceOfCountryResource(value: object): value is CountryResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CountryResourceFromJSON(json: any): CountryResource {
    return CountryResourceFromJSONTyped(json, false);
}

export function CountryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function CountryResourceToJSON(value?: CountryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

